import { getPluginTokenFromWindow, isPluginModeWindow } from "../redux/common";
import {isUserAuthenticated} from "./authUtils";
import cookieToken from "./cookieToken";

/**
 * Prepend the base path to a URL
 * @param {string} url The URL that will be processed
 * @returns {URL} The URL with the base path prepended
 */
const createApiURL = (url) => {
    // Prepend the base path
    return new URL('http' + (import.meta.env.VITE_USE_HTTPS==='1'?'s':'') + '://' +  import.meta.env.VITE_DOMAIN_NAME + import.meta.env.VITE_BASE_PATH + url);
}

/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 * @param {*} refresh
 */
const fetchJSON = async (url, options = {}, refresh = false) => {
    // Prepend the base path
    const final_url = createApiURL(url);

    const headers = {};
    if (['POST', 'PUT'].indexOf(options.method) !== -1 ) {
        headers['Content-Type'] = 'application/json';
    }

    const usePluginToken = isPluginModeWindow();

    if (usePluginToken) {
        const pluginToken = cookieToken.getPluginToken() || getPluginTokenFromWindow();
        if (pluginToken) {
            headers['Authorization'] = `Bearer ${pluginToken}`;
        }
    } else {
        const token = cookieToken.get();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
    }

    options = {
        ...options,
        headers: new Headers(headers)
    };

    if (options.search !== undefined) {
        final_url.search = new URLSearchParams(options.search);
    }

    try {
        const response = await fetch(final_url, options);
        const response_data = await response.json();

        if (response.status === 401) {
            // avoid loop
            if (refresh === false && isUserAuthenticated() === true) {
                try {
                    if (response_data.message === 'Token has expired') {
                        // Try to refresh token
                        const refresh_response = await fetchJSON('/login/refresh', {method: 'GET', headers: { 'Content-Type': 'application/json' }} , true);

                        if (usePluginToken) {
                            cookieToken.setPluginToken(refresh_response.token);
                        } else {
                            cookieToken.set(refresh_response.token);
                        }

                        return fetchJSON(url, options, true);
                    }
                } catch (e) {
                    console.warn(e);
                }
            }

            localStorage.removeItem('showTrialMessage');

            window.store.dispatch({ type: "APP_USER_NOT_CONNECTED", payload: {connected: false, user: null} });
            throw response_data;
        } else if (response.status !== 200 && response.status !== 202) {
            throw response_data;
        } else {
            if (response_data.success === false) {
                throw response_data;
            }

            return response_data.data;
        }
    } catch (e) {
        throw e;
    }
};

export { fetchJSON, createApiURL };
